import * as React from 'react';
import cx from 'classnames';
import { removeClass } from 'utils/domHelper';
import { numFormat } from 'utils/numFormat';
import styles from './RatingStarsUnit.css';
export default class RatingStarsUnit extends React.Component {
    constructor(props) {
        super(props);
        this.removeInitClass = () => {
            if (!this.unit) {
                this.timer = setTimeout(() => this.removeInitClass(), 10);
                return;
            }
            removeClass(this.unit, styles['init']);
        };
        this.handleClick = (rating) => () => {
            const { onClick, breakup } = this.props;
            typeof onClick === 'function' && onClick(((breakup && breakup.length) || 0) - rating);
        };
        this.setRatingRef = (c) => (this.unit = c);
        this.timer = null;
        this.unit = null;
    }
    componentDidMount() {
        this.timer = setTimeout(() => this.removeInitClass(), 50);
    }
    componentWillUnmount() {
        if (this.timer)
            clearTimeout(this.timer);
    }
    render() {
        const { breakup, largeBars } = this.props;
        if (!breakup || !breakup.length)
            return null;
        const reversed = breakup.slice(0).reverse();
        const largestRating = Math.max(...breakup);
        const listItemClass = cx(styles['listItem'], {
            [styles['pointer']]: typeof this.props.onClick === 'function'
        });
        const ratingContainer = largeBars ? styles['container-ul-1'] : styles['container-ul-2'];
        const barContainer = largeBars ? styles['container-ul-9'] : styles['container-ul-7'];
        const countContainer = largeBars ? styles['container-ul-2'] : styles['container-ul-3'];
        let ratingList = [];
        let barList = [];
        let countList = [];
        reversed.forEach((item, i) => {
            const keyPrefix = `${i}-${item}`;
            const barwidth = `${(item / largestRating) * 100}%`;
            ratingList.push(<li onClick={this.handleClick(i)} key={`${keyPrefix}-rating`} className={listItemClass}>
					<div className={styles['rating-container']}>
						<span className={styles['rating']}>{breakup.length - i}</span>
						<span className={styles['star']}>★</span>
					</div>
				</li>);
            barList.push(<li onClick={this.handleClick(i)} key={`${keyPrefix}-bar`} className={listItemClass}>
					<div>
						<div className={styles['bar']}>
							<span style={{ width: barwidth }} className={cx(styles['fill'], styles[`bar-color-${i + 1}`])}/>
						</div>
					</div>
				</li>);
            countList.push(<li onClick={this.handleClick(i)} key={`${keyPrefix}-count`} className={listItemClass}>
					<div className={styles['numbers']}>{`${numFormat(Number(item || 0))}`}</div>
				</li>);
        });
        return (<div ref={this.setRatingRef} className={cx(styles['rating-stars-container'], styles['outerContainer'], styles['init'])}>
				<ul className={ratingContainer}>{ratingList}</ul>
				<ul className={barContainer}>{barList}</ul>
				<ul className={countContainer}>{countList}</ul>
			</div>);
    }
}
